import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CombosList from "./CombosList";

const CombosModal = ({ open = false, onClose = () => {}, onSelect }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    outline: "none",
                    maxWidth: "94vw",
                    maxHeight: "92vh",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 3,
                        background: "rgba(255,255,255,0.85)",
                        "&:hover": { background: "#fff" },
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <CombosList onSelect={onSelect} onClose={onClose} />
            </Box>
        </Modal>
    );
};

export default CombosModal;
